// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","285":"06e9fd65","667":"9d720cb7","973":"fb691aca"}[chunkId] + ".chunk.js";
};